import { Grid, Typography } from '@mui/material';
import React from 'react';
import { type Slide } from '../../_data';
import { EditableField } from '../../components/EditableField';
import {
  calculateAllStrategyCount,
} from '../../components/ModelSetSlideTable';
// import ModelSetSlideTable, {
//   calculateAllStrategyCount,
// } from '../../components/ModelSetSlideTableV2';
import { getSlideField } from '../../utils';
// import { PremiumReportModelSetSlideTable } from 'components/SplitModelSetSlideTable/wrappers';
import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';
// import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';
// import ModelSetSlideTable from '../../components/ModelSetSlideTable';

export type Slide7ContentType = [
  {
    field: 'title';
    label: string;
    value: string;
    type: 'text';
  },
  {
    field: 'modelSet';
    label: string;
    value: string;
    type: 'modelSet';
  },
];

export const Slide7Content = React.memo(
  ({
    slide,
    onChangeSlide,
  }: {
    slide: Slide<Slide7ContentType>;
    onChangeSlide: (
      slide: Slide<Slide7ContentType>,
      content: Slide7ContentType,
    ) => void;
  }): React.ReactElement => {
    const item = getSlideField(slide, 'modelSet')?.value;
    const strategyCount = calculateAllStrategyCount(item);
    // let compactFontSize = '100%';
    // let groupHeaderHeight = 60;
    // switch (true) {
    //   case strategyCount > 10 && strategyCount <= 15:
    //     compactFontSize = '98%';
    //     groupHeaderHeight = 50;
    //     break;
    //   case strategyCount > 15:
    //     compactFontSize = '80%';
    //     groupHeaderHeight = 40;
    //     break;
    //   default:
    // }

    return (
      <Grid
        container
        direction="row"
        sx={{
          padding: '12px 12px 0 12px',
          height: '100%',
          width: '100%',
        }}
      >
        <Grid
          container
          sx={{
            width: '100%',
            height: 'calc(100% - 105px)',
            // overflow: 'scroll',
          }}
        >
          <Grid
            item
            sx={{
              textAlign: 'left',
              fontFamily: 'roboto',
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#004F7E',
            }}
          >
            <EditableField
              field={'title'}
              slide={slide}
              onSlideContentChange={onChangeSlide}
            />
          </Grid>
          <Grid
            item
            xs={12}
            pt={strategyCount > 15 ? 0 : 1}
            style={{
              height: '90%',
            }}
          >
            <ModelSetField item={item} slide={slide} />
          </Grid>
        </Grid>
        <Grid item xs={12} minHeight={105}>
          <Typography
            sx={{
              fontSize: '10px',
              color: '#7D7D7D',
              fontWeight: '400',
              marginLeft: '12px',
              marginTop: '12px',
              marginBottom: '12px',
              fontFamily: 'roboto',
            }}
          >
            * Based on stated maximum fees – may be lower based on any advisor
            exceptions or breakpoints AssetMark US/Global Market Blend is the
            default option for Core exposure in cases where an adviser has
            identified cost as a factor in the decision-making process and to
            the extent that an adviser is not seeking tactical,
            actively-managed, factor-based or socially-focused Core exposure.
            The consideration of AssetMark proprietary strategies, including
            strategies managed by AssetMark, during the investment consulting
            process creates a conflict of interest for AssetMark as AssetMark
            receives fees for the management of those strategies and funds.
          </Typography>
        </Grid>
      </Grid>
    );
  },
);

export default Slide7Content;

const ModelSetField = ({ item, groupHeaderHeight }: any) => {
  // console.log('item', item);
  // console.log('strategyCount', strategyCount);
  return (
    <Grid item xs={12}>
      {/* <SingleModelSetSlideTable
        slideMode
        action={{
          id: '',
          caseId: '',
          userId: '',
          milestoneId: '',
          versionName: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          draft: false,
          value: { model_set_holdings: [item] },
        }}
        modelSetName={item.model_set_name || ''}
        fontSize={12}
        enableCollapse={true}
        groupHeaderHeight={groupHeaderHeight}
      /> */}

      {/* <ModelSetSlideTable
        slideMode
        action={{
          id: '',
          caseId: '',
          userId: '',
          milestoneId: '',
          versionName: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          draft: false,
          value: { model_set_holdings: [item] },
        }}
        modelSetName={item.model_set_name || ''}
        fontSize={12}
        enableCollapse={true}
        groupHeaderHeight={groupHeaderHeight}
      /> */}

      <SplitModelSetSlideTable
        data={{
          id: '',
          caseId: '',
          userId: '',
          milestoneId: '',
          versionName: '',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          draft: false,
          value: { model_set_holdings: [item] },
        }}
        modelSetName={item.model_set_name || ''}
        slideMode={true}
        fontSize={12}
        groupHeaderHeight={groupHeaderHeight}
      />
    </Grid>
  );
};

